import { Component, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/components/icon/icon.component';
import { SideDialogService } from './side-dialog.service';

@Component({
  imports: [MatButtonModule, IconComponent, TranslateModule],
  selector: 'app-side-dialog',
  styleUrl: './side-dialog.component.scss',
  templateUrl: './side-dialog.component.html',
})
export class SideDialogComponent {
  public readonly disableClose = input<boolean>(false);
  public readonly contentMarginTop = input<number>(40);
  public readonly fullHeight = input<boolean>(false);
  public readonly paddingRight = input<number>(64);

  public closeDialog = output<void>();

  private readonly dialogRef = inject(MatDialogRef<SideDialogComponent>);
  private readonly sideDialogService = inject(SideDialogService);

  public close(): void {
    this.closeDialog.emit();

    if (!this.disableClose()) {
      this.sideDialogService.close(this.dialogRef);
    }
  }
}
